const inheritOption = { id: "", label: "Trashëgo nga prindi" };

export const LABEL_TITLE_OPTIONS = [
  inheritOption,
  { id: "universal_name", label: "Emri Universal" },
  { id: "universal_name_brand", label: "Emri Universal + Marka" },
  { id: "universal_name_brand_spec1", label: "Emri Universal + Marka + Specifika 1" },
  { id: "product_group_brand", label: "Grup Produkti + Marka" },
  { id: "final_category_brand", label: "Kategoria Fundore + Marka" },
  { id: "final_category_brand_spec1", label: "Kategoria Fundore + Marka + Specifika 1" },
  { id: "final_category_spec1_brand", label: "Kategoria Fundore + Specifika 1 + Marka" },
  { id: "spec1", label: "Specifika 1" },
  { id: "none", label: "Nuk Duhet Etikete" },
];

export const LABEL_SUBTITLE_OPTIONS = [
  inheritOption,
  { id: "model", label: "Modeli" },
  { id: "brand_model", label: "Marka + Modeli" },
  { id: "spec1", label: "Specifika 1" },
  { id: "none", label: "Nuk Duhet Etikete" },
];

export const LABEL_ENDING_OPTIONS = [
  inheritOption,
  { id: "model", label: "Modeli" },
  { id: "none", label: "Nuk Duhet Etikete" },
];

export const LABEL_PAPER_SIZE_OPTIONS = [
  inheritOption,
  { id: "a5", label: "A5" },
  { id: "a6", label: "A6" },
  { id: "a7", label: "A7" },
];

export function buildLabelRuleFields(current = {}) {
  return [
    [
      {
        value: current.label_title_rule ?? "",
        name: "label_title_rule",
        label: "Rregulli i titullit te etiketes",
        type: "select-field",
        options: LABEL_TITLE_OPTIONS,
        no_placeholder: true,
        style: "flex: 1",
      },
      {
        value: current.label_subtitle_rule ?? "",
        name: "label_subtitle_rule",
        label: "Rregulli i nentitullit te etiketes",
        type: "select-field",
        options: LABEL_SUBTITLE_OPTIONS,
        no_placeholder: true,
        style: "flex: 1",
      },
      {
        value: current.label_ending_rule ?? "",
        name: "label_ending_rule",
        label: "Rregull per rreshtin e pare te specifikave",
        type: "select-field",
        options: LABEL_ENDING_OPTIONS,
        no_placeholder: true,
        style: "flex: 1",
      },
    ],
    [
      {
        value: current.label_paper_size ?? "",
        name: "label_paper_size",
        label: "Madhesia e letres",
        type: "select-field",
        options: LABEL_PAPER_SIZE_OPTIONS,
        no_placeholder: true,
        style: "min-width: 30%",
      },
    ],
  ];
}
